import { Link } from "react-router";
import { useShopBlogPosts } from "@/lib/api.ts";
import { ArrowRight } from "lucide-react";

export function BlogPreviewSection() {
  const { data } = useShopBlogPosts(3);
  const posts = data?.posts ?? [];

  if (posts.length === 0) return null;

  return (
    <section className="py-20">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <h2 className="mb-10 text-[28px] font-medium tracking-tight text-heading">
          From the Blog
        </h2>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((post) => (
            <a
              key={post.id}
              href={`/blog/${post.slug}/`}
              className="group"
            >
              {post.heroImagePath && (
                <div className="aspect-[16/9] overflow-hidden bg-bg-alt">
                  <img
                    src={post.heroImagePath}
                    alt={post.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              )}
              <div className="pt-4">
                {post.publishedAt && (
                  <time className="text-xs text-text-muted">
                    {new Date(post.publishedAt).toLocaleDateString("en-US", {
                      month: "long",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </time>
                )}
                <h3 className="mt-1 text-[15px] font-medium leading-snug text-heading line-clamp-2">
                  {post.title}
                </h3>
                <span className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-heading">
                  Read More
                  <ArrowRight
                    size={12}
                    className="transition-transform group-hover:translate-x-1"
                  />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
